import { MenuSub } from '@/components/menu';
import { MegaMenuSubDropdown } from './components';
const MegaMenuBasicSetup = items => {
  const basicSetupItems = items.find(
    item => item.title === 'Basic Setup ' || item.title === 'Basic Setup'
  );

  return <MenuSub className="menu-default py-2.5 lg:w-[225px]">
    {basicSetupItems.children && MegaMenuSubDropdown(basicSetupItems.children)}
  </MenuSub>;
};
export { MegaMenuBasicSetup };